export enum NotificationOffsetUnit {
  Minutes = 0,
  Hours = 1,
  Days = 2,
  Weeks = 3
}
